import { NullObj } from './NullObj';
import { EnvObjType } from './obj';
export class BuiltInFunctionObj {
    constructor(fn = () => new NullObj()) {
        this.fn = fn;
    }
    get Fn() {
        return this.fn;
    }
    set Fn(val) {
        this.fn = val;
    }
    Type() {
        return EnvObjType.BUILTIN;
    }
    Inspect() {
        return 'builtin function';
    }
    toJSON() {
        return 'TODO';
    }
    toJS() {
        return () => null; // not sure
    }
    Equals(obj) {
        return obj === this;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQnVpbHRpbkZ1bmN0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2xpYi9lbnYvQnVpbHRpbkZ1bmN0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxPQUFPLEVBQUUsTUFBTSxXQUFXLENBQUM7QUFDcEMsT0FBTyxFQUFVLFVBQVUsRUFBRSxNQUFNLE9BQU8sQ0FBQztBQUkzQyxNQUFNLE9BQU8sa0JBQWtCO0lBQzNCLFlBQW9CLEtBQXNCLEdBQUcsRUFBRSxDQUFDLElBQUksT0FBTyxFQUFFO1FBQXpDLE9BQUUsR0FBRixFQUFFLENBQXVDO0lBQUcsQ0FBQztJQUVqRSxJQUFJLEVBQUU7UUFDRixPQUFPLElBQUksQ0FBQyxFQUFFLENBQUM7SUFDbkIsQ0FBQztJQUNELElBQUksRUFBRSxDQUFDLEdBQUc7UUFDTixJQUFJLENBQUMsRUFBRSxHQUFHLEdBQUcsQ0FBQztJQUNsQixDQUFDO0lBRUQsSUFBSTtRQUNBLE9BQU8sVUFBVSxDQUFDLE9BQU8sQ0FBQztJQUM5QixDQUFDO0lBRUQsT0FBTztRQUNILE9BQU8sa0JBQWtCLENBQUM7SUFDOUIsQ0FBQztJQUVELE1BQU07UUFDRixPQUFPLE1BQU0sQ0FBQztJQUNsQixDQUFDO0lBRUQsSUFBSTtRQUNBLE9BQU8sR0FBRyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsV0FBVztJQUNsQyxDQUFDO0lBRUQsTUFBTSxDQUFDLEdBQVc7UUFDZCxPQUFPLEdBQUcsS0FBSyxJQUFJLENBQUM7SUFDeEIsQ0FBQztDQUNKIn0=